<template>
  <nav class="fixed bg-white z-20 bottom-0 w-full border-t shadow">
    <ul class="h-full grid grid-cols-4 justify-between">
      <li class="flex">
        <div
          @click="setFilters"
          class="w-full h-full flex justify-center items-center"
        >
          <Icon name="Adjustments" class="w-8 mr-2" />
        </div>
      </li>
      <li class="flex">
        <router-link
          to="/"
          class="w-full h-full flex justify-center items-center"
        >
          <Icon name="Grid" class="w-8 mr-2" />
        </router-link>
      </li>
      <li class="flex">
        <router-link
          to="/menu"
          class="w-full h-full flex justify-center items-center"
        >
          <Icon
            name="MenuHamburger"
            viewbox="0 0 22 22"
            fill="#3c3c3c"
            stroke="#3c3c3c"
            class="w-6 mr-2"
          />
        </router-link>
      </li>
      <li v-if="user">
        <router-link
          to="/account"
          class="w-full h-full flex justify-center items-center"
        >
          <img :src="user.picture" alt="" class="w-10" />
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import Icon from "@/components/UI/Icon";
import { useRouter } from "vue-router";

export default {
  components: { Icon },
  setup() {
    const store = useStore();
    const router = useRouter();
    const user = computed(() => store.state.user);
    const setFilters = () => {
      console.log(router.currentRoute.value.name);
      router.push({
        name: "Filters",
        params: { pageName: router.currentRoute.value.name },
      });
    };
    return { user, setFilters };
  },
};
</script>

<style scoped>
nav {
  height: 60px;
}
</style>
